import { Button } from "antd";
import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import { Container } from "./styles";

interface IItemsToChooseBundleProps {
  lowestPrice?: any;
  isContentScreen?: any;
  isProductBundleScreen?: any;
  setShowBundlesOverlay?: any;
  isCourseLandingPageCard?: any;
  isCourseLandingPageFooter?: any;
}

const ItemsToChooseBundle = ({
  lowestPrice,
  isContentScreen,
  isProductBundleScreen,
  setShowBundlesOverlay,
  isCourseLandingPageCard,
  isCourseLandingPageFooter,
}: IItemsToChooseBundleProps) => {
  return (
    <Container
      isContentScreen={isContentScreen}
      isProductBundleScreen={isProductBundleScreen}
      isCourseLandingPageCard={isCourseLandingPageCard}
      isCourseLandingPageFooter={isCourseLandingPageFooter}
    >
      <div className="prices-plus-info">
        {(isCourseLandingPageCard || isContentScreen) && (
          <>
            <h5 className="label">
              <StaticIntlTranslator id="common:chooseOnePaymentOption" />
            </h5>

            <span className="starting-at outside-footer">
              <StaticIntlTranslator id="common:startingAt" />
            </span>
          </>
        )}

        <div className="prices">
          {isCourseLandingPageFooter && (
            <span>
              <StaticIntlTranslator id="common:startingAt" />
            </span>
          )}

          <section className="price">{lowestPrice}</section>
        </div>
      </div>

      <Button
        type="primary"
        className="buy-btn"
        onClick={() => setShowBundlesOverlay(true)}
      >
        <StaticIntlTranslator id="common:seePaymentOptions" />
      </Button>
    </Container>
  );
};

export default ItemsToChooseBundle;
